(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-lt-cart"]) return;
  try {
    
/* ============================================================
   LT Cart page (#18) — free-shipping progress + count updater.
   The stock CartItems refreshes [data-line-items]/[data-cart-final] on every
   change but knows nothing about our custom progress block or the units-aware
   count. This keeps both live between page loads. It NEVER mutates the cart —
   it only reads the cart payload the change event already carries, and formats
   money through the theme's own themeCurrency (no hand-built money strings).
   ============================================================ */
(function () {
  'use strict';

  function money(cents) {
    try {
      return window.themeVendor.themeCurrency.formatMoney(cents, window.theme.moneyFormat);
    } catch (e) {
      return '';
    }
  }

  // #143: locale strings for the item-count / status text below, read once
  // from the JSON bridge the Liquid markup renders. Missing/blank map ->
  // the hardcoded English literal (unchanged behaviour), same map.key ||
  // '<old literal>' contract #142 established for this theme's JS files.
  function ltCartStrings() {
    try {
      var el = document.querySelector('[data-lt-cart-strings]');
      return el ? JSON.parse(el.textContent) : {};
    } catch (e) {
      return {};
    }
  }
  var LT_STR = ltCartStrings();

  function itemsText(n) {
    var singular = LT_STR.item_singular || 'item';
    var plural = LT_STR.item_plural || 'items';
    return n + ' ' + (n === 1 ? singular : plural);
  }

  // Units-aware count, tolerant of every cart payload shape: the
  // /cart/change response strips has_components off the merged parent
  // (properties survive — Vera proved it live, #18 round 3b, the header
  // badge kept counting right through the same event). So the parent is
  // detected by its PROPERTIES alone: the Cart Transform stamps _lt_units
  // on the merged parent ONLY (lettoon-functions/lt-pack-transform/src/
  // cart_transform_run.js L97) — component and journal rider lines carry
  // _lt_pack but never _lt_units. has_components stays as a belt-and-
  // braces OR for payloads that do include it.
  function unitsCount(cart) {
    return (cart.items || []).reduce(function (sum, line) {
      var props = line.properties || {};
      if (props._lt_pack && (props._lt_units != null || line.has_components)) {
        var u = parseInt(props._lt_units, 10);
        return sum + (isNaN(u) ? line.quantity : u);
      }
      return sum + line.quantity;
    }, 0);
  }

  function update(cart) {
    if (!cart || !Array.isArray(cart.items)) return;
    var grid = document.querySelector('[data-lt-cart]');
    if (!grid) return;

    var countEl = document.querySelector('[data-lt-cart-count]');
    var n = unitsCount(cart);
    if (countEl) {
      countEl.textContent = itemsText(n);
    }
    // #68 finding 8: composed summary, e.g. "6 items, total €44.99" — the
    // same money() helper the shipping-away line above already uses.
    // #143: "{items}, total {money}" locale template so the whole sentence
    // translates as one unit (not two concatenated English halves) — {items}
    // is itself already-localized text (itemsText(n)), so this substitutes
    // ONE pre-localized phrase into ONE placeholder, not raw word fragments.
    var statusEl = document.querySelector('[data-lt-cart-status]');
    if (statusEl) {
      // #143: single-brace markers, deliberately not Liquid's own double-mustache
      // interpolation syntax — theme check's StaticStylesheetAndJavascriptTags
      // rule pattern-matches that syntax inside a javascript block even inside a
      // plain JS string literal (even inside a comment), so using it here would
      // add a NEW offense class this ticket's acceptance bar doesn't allow.
      var summaryTpl = LT_STR.status_total || '{items}, total {money}';
      var moneyText = money(cart.total_price).replace(/<[^>]*>/g, '');
      statusEl.textContent = summaryTpl.replace('{items}', itemsText(n)).replace('{money}', moneyText);
    }

    var threshold = parseInt(grid.getAttribute('data-lt-cart-threshold'), 10);
    var ship = grid.querySelector('[data-lt-cart-ship]');
    if (!ship || isNaN(threshold) || threshold <= 0) return;

    var below = ship.querySelector('[data-lt-cart-ship-below]');
    var free = ship.querySelector('[data-lt-cart-ship-free]');
    // Tax-note pair swaps with the banner: full "Shipping & taxes" copy
    // below the threshold, taxes-only once free shipping is unlocked
    // (the banner already claims shipping). Same hidden-toggle pattern.
    var taxBelow = grid.querySelector('[data-lt-cart-tax-below]');
    var taxFree = grid.querySelector('[data-lt-cart-tax-free]');
    var remaining = threshold - cart.total_price;

    if (remaining > 0) {
      if (below) {
        below.hidden = false;
        var away = below.querySelector('[data-lt-cart-ship-away]');
        var fill = below.querySelector('[data-lt-cart-ship-fill]');
        // innerHTML, NOT textContent: shop.money_format ships with markup
        // ("<span class=money>...") and formatMoney keeps it, so textContent
        // printed the tags literally into the away line (Vera, #18 round
        // 3b). Safe to write as HTML: the only interpolated value is the
        // amount formatMoney produced from a number we computed — nothing
        // user-controlled ever enters this string.
        if (away) away.innerHTML = money(remaining);
        if (fill) fill.style.width = Math.min(100, cart.total_price / threshold * 100).toFixed(1) + '%';
      }
      if (free) free.hidden = true;
      if (taxBelow) taxBelow.hidden = false;
      if (taxFree) taxFree.hidden = true;
    } else {
      if (below) below.hidden = true;
      if (free) free.hidden = false;
      if (taxBelow) taxBelow.hidden = true;
      if (taxFree) taxFree.hidden = false;
    }
  }

  document.addEventListener('theme:cart:change', function (e) {
    if (e.detail && e.detail.cart) update(e.detail.cart);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
